module.exports = __webpack_public_path__ + "media/src/images/icons/edit_emptystate-e8ff6004ef7103ef2a2c3854a905843a.svg";